import parsePhoneNumber from 'libphonenumber-js'

export function validateTelephone(telephone) {
  const phoneNumber = parsePhoneNumber(telephone)
  if (phoneNumber) {
    return phoneNumber.isValid()
  }
  return false
}
